<main>
    <div class="app app-margin" [dir]="textDir">
        <div class="app-container-pm">
            <section class="nav-area-sm" >             
                <div class="row top-section padT15">
                    <div class="md-12 lg-12 xl-12">
                        <section class="breadcrmb">
                            <a [routerLink]="['/']" class="breadcrum">{{'Home' | translate}}</a> /
                            <a [routerLink]="['/projectmanagement']" class="breadcrum">{{'Project management' | translate}}</a> /
                            <a [routerLink]="['/projectmanagement',this.project_id, 'view']" class="breadcrum">{{this.projectData?.name}}</a> /
                            <span class="active font12">{{'Setup Project' | translate}}</span>
                        </section>
                        <h4 class="marT10 header-title">{{this.projectData?.name}}</h4>
                    </div>
                </div>
                <!-- <div id="col-title" class="row">
                    <div class="lg-3">
                        <h4>&nbsp;</h4>
                    </div>
                    <div class="lg-6">
                        <h4 class="titleColor" style="padding-top:10px;">{{this.wizardStepsTitle[currentSteps-1]}}</h4>
                    </div>
                    <div class="lg-3">
                        <h4>&nbsp;</h4>
                    </div>
                </div> -->
            </section>
            <div class="app-container top-section marT20" [dir]="textDir">
                <div class="row">
                    <div class="lg-3 projectSetup wiz-pos marT30">
                        <!-- Steps panle in left start-->
                        <app-ctl-wizard-steps [ctlSteps]=this.wizardSteps [activestep]=currentSteps></app-ctl-wizard-steps>
                        <!-- Steps panle in left end-->
                    </div>
                    <div class="lg-6">
                        <div class="prehight-addproject form-wid eds-white" >
                            <div *ngIf="currentSteps==1" class="white">
                                <app-ctl-prj-grade-form
                                    [type]="'add'"
                                    [projectData]="projectData"
                                    [myFormGroup]="gradeYearForm"
                                    [myGradeList]="projGradeList"
                                    [myYearList]="yearList"  
                                    [cancelClicked]="cancelClicked.asObservable()"
                                    (evBtnStatus)="btnStatus($event)"                               
                                    (evRemoveGrade)="removeGrade($event)">
                                </app-ctl-prj-grade-form>
                            </div>
                            <div *ngIf="currentSteps==2" class="white">
                                <app-ctl-prj-subject-form
                                    [type]="'add'"
                                    [projectData]="projectData"
                                    [mySelectedSubjectsList]="selectedSubjectsList"
                                    [mySubjectList]="subjectsList"
                                    (evAddSubject)="onAddSubject($event)"
                                    (evRemoveSubject)="removeSubject($event)">
                                </app-ctl-prj-subject-form>
                            </div>
                            <div *ngIf="currentSteps==3" class="white">
                                <app-ctl-prj-setup-review
                                    [gradeData]="gradeList"
                                    [subjectData]="selectedSubjectsList"
                                    (evEdit)="backStep($event)"
                                    [projectData]="projectData">
                                </app-ctl-prj-setup-review>
                            </div>
                            
                            <div class="white-bg marB20">
                                <hr>
                               <div class="row spaceBtwn marT20">
                                    <div>
                                        <a [routerLink]="['/projectmanagement',this.project_id, 'view']" class="btn btn-cancel">{{'Cancel' | translate}} </a>
                                    </div>
                                    <div> 
                                        <button (click)='backStep()' *ngIf="currentSteps > 1 && currentSteps < 4" class="btn btn-back marR15"><i class="icon icon-arrow-left"></i>{{'Back' | translate}} </button>
                                        <button (click)='nextStep()' *ngIf="currentSteps==1" class="btn btn-next primary" [disabled]='nextBtnDisbaled'>{{'Next' | translate}} <i class="icon icon-arrow-right"></i></button>
                                        <button (click)='nextStep()' *ngIf="currentSteps==2" class="btn btn-next primary" [disabled]='reviewBtnDisbaled'>{{'Review' | translate}} <i class="icon icon-arrow-right"></i></button>
                                        <button (click)='finalStep()' *ngIf="currentSteps==3" class="btn btn-next primary">{{'Complete' | translate}} </button>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        
                    </div>
                    <div class="lg-3 reference-list marT10" *ngIf="currentSteps==1">
                        <div class="year-list">
                            <!-- <a class="lineheight29 cursor " data-placement="left " data-toggle="tooltip " title="Please find the year age group mapping for reference.">
                                <img src="assets/images/info.png ">
                            </a> -->
                            <div class="marL25 marT25 marR25 marB10">
                                <div class="marLR5 grey-text"><span _ngcontent-yxo-c77="" _ngcontent-qmd-c83="" class="optional">*</span>{{'Reference years' | translate}}</div>
                            </div>
                            <ul class='year'>
                                <!-- <hr *ngIf="showYearCategory(year)"> -->
                                <!-- <li *ngIf="showYearCategory(year)">&nbsp;</li> -->
                                <li [ngClass]="showYearCategory(year) ? 'marT10' : ''"  *ngFor="let year of this.absYearList; let i=index">
                                    <div class="h-line marB15" *ngIf="showYearCategory(year)"> </div>
                                    <div>
                                        <div class="lg-5 xl-5 sm-5 yr-cat" *ngIf="showYearCategory(year)">{{year?.category}}</div>
                                        <div class="lg-5 xl-5 sm-5 yr-cat" *ngIf="!showYearCategory(year)">&nbsp;</div>
                                        <div class="lg-6 xl-6 sm-6 yr">{{year?.name}}</div>
                                        <!-- <div class="lg-5 xl-5 sm-3 yr">{{year?.description}}</div>       -->
                                    </div>
                                    <div style="clear: both;"></div>
                                                                
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>